/**
 * @file [CheckboxGroup]
 * @author (spu-fe)
 */
import CheckboxGroup from './CheckboxGroup.js';
import Checkbox from './Checkbox.js';
export { Checkbox, CheckboxGroup };
export default CheckboxGroup;